import { render } from "./perMission.vue?vue&type=template&id=643243e6&scoped=true"
import script from "./perMission.vue?vue&type=script&lang=js"
export * from "./perMission.vue?vue&type=script&lang=js"

import "./perMission.vue?vue&type=style&index=0&id=643243e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643243e6"]])

export default __exports__